<template>
  <div class="content-wrapper" :class="{ 'news': news !== null }">
    <div class="navbar" v-show="nav === 'true'">
      <router-link :to="{ name: 'gallery' }">
        <font-awesome-icon icon="hand-point-left"/>&nbsp;Gallery
      </router-link>
      <span v-show="admin === 'true'">
        <router-link :to="{ name: 'news' }">
          <font-awesome-icon icon="exclamation-triangle"/>&nbsp;News
        </router-link>
        <router-link :to="{ name: 'orders' }">
          <font-awesome-icon icon="credit-card"/>&nbsp;Orders
        </router-link>
        <router-link :to="{ name: 'events' }">
          <font-awesome-icon icon="calendar-alt"/>&nbsp;Events
        </router-link>
        <router-link :to="{ name: 'bakes' }">
          <font-awesome-icon icon="cookie-bite"/>&nbsp;Bakes
        </router-link>
        <router-link :to="{ name: 'subscribers' }">
          <font-awesome-icon icon="at"/>&nbsp;Subscribers
        </router-link>
        <router-link :to="{ name: 'testimonials' }">
          <font-awesome-icon icon="comment-dots"/>&nbsp;Testimonials
        </router-link>
      </span>
    </div>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Content',
  props: ['nav', 'admin', 'news']
}
</script>

<style lang="less" scoped>
.content-wrapper {
  background-color: rgba(255, 255, 255, 0.9);
  border-top: 7px solid #aae8e2;

  &.news {
    border-top: none;
  }

  .navbar {
    padding: 1em;

    a {
      color: #413276;
      text-decoration: none;
    }

    a:hover,
    a.router-link-exact-active,
    a.router-link-active {
      border-bottom: 1px dashed #3e2e73;
      color: #3e2e73;
    }

    span {
      float: right;

      a {
        margin-left: 1.5em;
      }
    }
  }

  .content {
    margin: auto;
    max-width: 1024px;
    padding: 1em 1em 3em 1em;
  }
}
</style>
